// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.add-staff-modal__container .modal2__container{
    padding: unset;
    max-width: unset;
    width: 40%;    
}

.add-staff-modal__container .modal2__content{
    padding: var(--space-x2);  
}

.add-staff-modal__content{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: var(--space);
}

.add-staff-modal__container-create.baloa-name{
    justify-content: center;
    color: var(--primary-very-dark-color);
    font-size: 17px;
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
    
}

.add-staff-modal__buttons{
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
    border-top: 1px solid var(--new-input-background-color);
}

.add-staff-modal__content .baloa-table{
    color: var(--primary-very-dark-color);
}

.add-staff-modal__description{
    display: flex;
    align-items: center;
    width: 100%;
    gap: var(--space);
}

.add-staff-modal__description .icon-wistle,
.add-staff-modal__description .icon-trophy,
.add-staff-modal__description .hubicon-manage_accounts-1,
.add-staff-modal__description .hubicon-assignment_ind{
    font-size: 24px;
    color: var(--basic-gray-color);
}

.add-staff-modal__link{
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: var(--space);
    max-width: 100%;
    
}

.add-staff-modal__link .baloa-table{
    background: var(--new-background-color);
    padding: 11px;
    border-radius: 4px;
    overflow: hidden;
    white-space: nowrap; /* Don't forget this one */
    text-overflow: ellipsis;
}

.add-staff-modal__condition{
    margin-top: var(--space);
    display: flex;
    align-items: center;
    width: 100%;
    text-align: justify;
}

.add-staff-modal__o{
    margin-top: var(--space);
    align-items: center;
    width: 100%;
    text-align: center;
}

.add-staff-modal__condition.baloa-username{
    color: var(--primary-dark-color);
}

.icon-copy-86{
    margin-left: 12px;
    background-color: var(--white-color);
}

/* .add-staff-modal__search{
    display: flex;
    justify-content: center;
} */

.add-staff-modal__search__form{
    display: flex;
    justify-content: center;
    margin-top: var(--space);
    align-items: center;
}

.add-staff-modal__search__user-input {
    margin-right: var(--space);
    width: 80%;
}

.add-staff-modal__search__button__submit-button.small{
    padding: calc(var(--space-half) + var(--space-eighth)) var(--space-x2);
}

.add-staff-modal__search .hubicon-clear_option{
    padding: 5px;
    border-radius: 50%;
    background-color: var(--new-gray-background-color);
}

.add-staff-modal__search .MuiListItem-container{
    list-style-type: none;
    width: 100%;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    background-color: var(--new-background-color);
    margin-right: 10px;
}

.add-staff-modal__search .MuiListItem-container .MuiListItem-root{
    padding-top: unset;
    padding-bottom: unset;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .add-staff-modal__description .hubicon-code {
        margin-right: var(--space-half);
    }

    .add-staff-modal__buttons {
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-add-staff-modal/TournamentAddStaffModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uDAAuD;AAC3D;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;;IAII,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,eAAe;;AAEnB;;AAEA;IACI,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE,0BAA0B;IAC/C,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;;;GAGG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,sEAAsE;AAC1E;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,kDAAkD;IAClD,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["\n.add-staff-modal__container .modal2__container{\n    padding: unset;\n    max-width: unset;\n    width: 40%;    \n}\n\n.add-staff-modal__container .modal2__content{\n    padding: var(--space-x2);  \n}\n\n.add-staff-modal__content{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: var(--space);\n}\n\n.add-staff-modal__container-create.baloa-name{\n    justify-content: center;\n    color: var(--primary-very-dark-color);\n    font-size: 17px;\n    text-align: center;\n    margin-left: 15px;\n    margin-right: 15px;\n    \n}\n\n.add-staff-modal__buttons{\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 16px;\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.add-staff-modal__content .baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.add-staff-modal__description{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: var(--space);\n}\n\n.add-staff-modal__description .icon-wistle,\n.add-staff-modal__description .icon-trophy,\n.add-staff-modal__description .hubicon-manage_accounts-1,\n.add-staff-modal__description .hubicon-assignment_ind{\n    font-size: 24px;\n    color: var(--basic-gray-color);\n}\n\n.add-staff-modal__link{\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-top: var(--space);\n    max-width: 100%;\n    \n}\n\n.add-staff-modal__link .baloa-table{\n    background: var(--new-background-color);\n    padding: 11px;\n    border-radius: 4px;\n    overflow: hidden;\n    white-space: nowrap; /* Don't forget this one */\n    text-overflow: ellipsis;\n}\n\n.add-staff-modal__condition{\n    margin-top: var(--space);\n    display: flex;\n    align-items: center;\n    width: 100%;\n    text-align: justify;\n}\n\n.add-staff-modal__o{\n    margin-top: var(--space);\n    align-items: center;\n    width: 100%;\n    text-align: center;\n}\n\n.add-staff-modal__condition.baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.icon-copy-86{\n    margin-left: 12px;\n    background-color: var(--white-color);\n}\n\n/* .add-staff-modal__search{\n    display: flex;\n    justify-content: center;\n} */\n\n.add-staff-modal__search__form{\n    display: flex;\n    justify-content: center;\n    margin-top: var(--space);\n    align-items: center;\n}\n\n.add-staff-modal__search__user-input {\n    margin-right: var(--space);\n    width: 80%;\n}\n\n.add-staff-modal__search__button__submit-button.small{\n    padding: calc(var(--space-half) + var(--space-eighth)) var(--space-x2);\n}\n\n.add-staff-modal__search .hubicon-clear_option{\n    padding: 5px;\n    border-radius: 50%;\n    background-color: var(--new-gray-background-color);\n}\n\n.add-staff-modal__search .MuiListItem-container{\n    list-style-type: none;\n    width: 100%;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    background-color: var(--new-background-color);\n    margin-right: 10px;\n}\n\n.add-staff-modal__search .MuiListItem-container .MuiListItem-root{\n    padding-top: unset;\n    padding-bottom: unset;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .add-staff-modal__description .hubicon-code {\n        margin-right: var(--space-half);\n    }\n\n    .add-staff-modal__buttons {\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
